import fetchWrapper from "@/api/fetch-wrapper";

export const getRisks = () => {
    const query = `ajax/getRisks.php`;
    return fetchWrapper.get(query)
}

export const getUniqCode = () => {
    const query = `ajax/getUniqCode.php`;
    return fetchWrapper.get(query)
}

export const checkExcludeUtm = (utmList) => {
    let utmListQuery = utmList.map(function(value) {
        return encodeURIComponent('utm_list[]') + '=' + encodeURIComponent(value);
    }).join('&');

    const query = `ajax/checkExcludeUtm.php?` + utmListQuery;
    return fetchWrapper.get(query)
}